module.exports = __webpack_public_path__ + "img/dd6.aa607c21.jpg";